import type { UrlService } from './url';

import { Environment } from '../../../environments/environment';

export function Params(this: UrlService): Record<string, unknown> {
  const _params: Record<string, unknown> = {};

  // Add contemporary filtering params to URL.
  for (const [_key, _value] of Object.entries(this.filteringService.params())) {
    if (_value === undefined) {
      continue;
    }

    Object.assign(_params, { [_key]: _value });
  }

  // Add legacy params to URL for backward compatibility.
  // if (this.filteringService.lat() && this.filteringService.lng() && this.filteringService.lvl() !== environment.mapZoom) {
  //   Object.assign(_params, { lng: this.filteringService.lng(), lat: this.filteringService.lat() });
  // }

  if (
    this.filteringService.lat() !== Environment.mapCenter[1] ||
    this.filteringService.lng() !== Environment.mapCenter[0]
  ) {
    Object.assign(_params, { lat: this.filteringService.lat(), lng: this.filteringService.lng() });
  }

  if (
    this.filteringService.lvl() &&
    this.filteringService.lvl() !== Environment.mapZoom &&
    this.filteringService.lvl() !== -1
  ) {
    Object.assign(_params, { lvl: this.filteringService.lvl() });
  }

  return _params;
}
